import React, { createContext, useContext, useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useFindOneUserQuery } from '~/graphql/generated/graphql';
import { isProfileComplete, sanitizePersonData, stripCountryCode } from '~/utils/profileUtils';

const ProfileContext = createContext({});

const initialValue = {
  fullname: '',
  cpf: '',
  rg: '',
  gender: '',
  birthday: '',
  addresses: {
    zipcode: '',
    street: '',
    street_number: '',
    complement: '',
    neighborhood: '',
    city: '',
    state: '',
    country: '',
  },
  contacts: {
    name: '',
    category_id: 7,
    number: '',
  },
};

export const ProfileProvider = ({ children }) => {
  const [dataProfile, setDataProfile] = useState([]);
  const [dataPerson, setDataPerson] = useState([initialValue]);
  const [dataRanking, setDataRanking] = useState([]);
  // const [listTypeContacts, setListTypeContacts] = useState([]);
  const [cardData, setcardData] = useState([]);
  const [test, setTest] = useState('');
  const navigate = useNavigate();
  const hasRedirectedToProfile = useRef(false);

  const { data, loading, error } = useFindOneUserQuery({
    fetchPolicy: 'network-only', // Sempre busca do servidor, evitando dados cacheados de outro usuário
  });

  useEffect(() => {
    if (loading || error) return;

    if (data?.findOneUser) {
      const user = data.findOneUser;

      // Monta o objeto de profile compatível com o formato anterior
      setDataProfile({
        id: user.id,
        key: user.key,
        email: user.email,
        nickname: user.nickname,
        is_active: user.is_active,
        terms: user.terms,
        roles: user.roles,
        roleScope: user.roles,
        avatar: user.avatar,
        ranking: user.ranking,
        wallet: user.wallets,
        person: user.persons,
      });

      // Define o ranking
      setDataRanking(user.ranking);

      // Define os dados da pessoa (sanitiza valores "Temp" para não aparecerem na UI)
      const person = user.persons;
      if (person === null || person === undefined) {
        setDataPerson(initialValue);
      } else {
        const contactData = person.contacts?.[0] || initialValue.contacts;
        setDataPerson(sanitizePersonData({
          ...person,
          addresses: person.addresses?.[0] || initialValue.addresses,
          contacts: {
            ...contactData,
            number: stripCountryCode(contactData.number),
          },
        }));
      }

      // Redireciona para perfil apenas uma vez após o login se o perfil não estiver completo.
      // Após o redirecionamento inicial, o usuário pode navegar livremente.
      if (!hasRedirectedToProfile.current && !isProfileComplete(person)) {
        hasRedirectedToProfile.current = true;
        navigate('/dashboard/perfil');
      }
    }
  }, [data, loading, error, navigate]);

  // Computed: o perfil está completo?
  const profileComplete = isProfileComplete(dataPerson);

  return (
    <ProfileContext.Provider
      value={{
        dataProfile,
        dataPerson,
        dataRanking,
        initialValue,
        cardData,
        // listTypeContacts,
        test,
        loading,
        error,
        profileComplete,
        setTest,
        setDataPerson,
        setcardData,
        setDataRanking,
        setDataProfile,
      }}
    >
      {children}
    </ProfileContext.Provider>
  );
};

export function useProfile() {
  const context = useContext(ProfileContext);

  return context;
}
